import React, { Component } from 'react';
import axios from 'axios'
import Slider from "react-slick";

const settings = {
    autoplay: false,
    draggable: false,
    prevArrow : <img src={"/assets-2021/img/critiques-home-prev.svg"}/>,
    nextArrow : <img src={"/assets-2021/img/critiques-home-next.svg"}/>,
    arrows : true,
    slidesToShow: 2,
    centerMode:true,
    centerPadding:'26px',
    responsive: [
        {
            breakpoint: 768,
            settings: {
                draggable: true,
                arrows: false,
            },
        },
    ],

};
class CritiquesHome extends Component {
    constructor(){
        super();
        this.state = {
            products: []
        }
        this.initprods = this.initprods.bind(this)
    }

    componentDidMount(){
        this.initprods()
    }

    initprods(){
        let that = this;
        axios.get('https://critiquesadmin.she.com/api/shehomepop')
            .then(function (response) {
                if(response.data.code == 200){
                    let resdata = response.data.data
                    console.log(resdata)
                    that.setState({ products:resdata })
                }
            })
            .catch(function (error) {
                console.log(error)
            })
    }
    render(){

        const { products } = this.state


        return (
            <div className={"critiques-home-container"}>
                <div className={"critiques-home-logo"}><img src={'/assets-2021/img/critiques-home-logo.png'}/></div>
                <div className={"critiques-home-prods"}>
                    <Slider {...settings}>
                        {products.map((item, index) => {
                            console.log(Math.round(item.Score));
                            var score = Math.round(item.Score)
                            return(
                                <div key={index} className={"critiques-home-prod"}>

                                    <div className={"critiques-home-prod-img"}>
                                        <a href={"https://critiques.she.com/product/info/"+item.nameZh+"/"+item.EntityId} target={"_blank"}>
                                            <img src={item.ImageUrl}/>
                                        </a>

                                    </div>
                                    <div className={"critiques-home-prod-detail"}>
                                        <div className={"critiques-home-prod-brand"}>
                                            <a href={"https://critiques.she.com/brand/info/"+item.brand.NameEn+"/"+item.BrandId} target={"_blank"}>
                                                {item.brand.NameEn}
                                            </a>

                                        </div>
                                        <div className={"critiques-home-prod-name"}>
                                            <a href={"https://critiques.she.com/product/info/"+item.nameZh+"/"+item.EntityId} target={"_blank"}>
                                                {item.NameEn==''?item.NameZh : item.NameEn}
                                            </a>
                                        </div>
                                        <div className={"critiques-home-prod-star"}>
                                            {[...Array(score)].map((x, i) =>
                                                <img src={'/assets-2021/img/critiquesstar.svg'}/>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </Slider>
                </div>
            </div>
        )
    }
}

export default CritiquesHome



// WEBPACK FOOTER //
// ./src/CritiquesHome.js